module.exports = __webpack_public_path__ + "img/get-money.cf3be110.png";